import SessionStore from "./SessionStore";

const rootStore = {
  sessionStore: new SessionStore(this),
};

export default rootStore;